<template>
  <div class="index_news container">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img src="../../static/index/recommend/recommend-icon.png" />
        </div>
        新闻资讯
      </div>
      <div class="head-right" @click="gonews()">
        查看更多
        <div class="icon"></div>
      </div>
    </div>
    <div class="news-list">
      <div class="row hidden-xs">
       
          

          <div class="swiper-container pcnews">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in newlistTemp"
              :key="item.id"
            >
              <div class="row">
                <div
                  class="col-lg-4 col-md-4"
                  v-for="(item, i) in item" :key="i"
                  @click="navigator(item.id, item.is_ad)"
                >
                <div class="news_item">
            <div
              class="item_img"
              :style="{ backgroundImage: 'url(' + item.photopath + ')' }"
            >
              <img :src="item.photopath" />
            </div>
            <div class="item_con">
              <div class="con_title">{{ item.title }}<ins></ins></div>
              <div class="con_desc">
                {{ item.subtitle }}
              </div>
              <div class="con_more">了解详情</div>
            </div>
          </div>
              </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <!-- <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div> -->
          <!-- 如果需要滚动条 -->
          <!--    <div class="swiper-scrollbar"></div>-->
        </div> 



        
      </div>

      <div
        class="swiper_list container-build mb60 hidden-lg hidden-md hidden-sm"
      >
        <div class="swiper-container news">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in news_list"
              :key="item.id"
              @click="navigator(item.id, item.is_ad)"
            >
              <div class="swiper-item swiper">
                <div class="news_item">
                  <div
                    class="item_img"
                    :style="{ backgroundImage: 'url(' + item.photopath + ')' }"
                  >
                    <!-- <img src="../../static/index/news/1.png" /> -->
                  </div>
                  <div class="item_con">
                    <div class="con_title">{{ item.title }}<ins></ins></div>
                    <div class="con_desc">
                      {{ item.subtitle }}
                    </div>
                    <div class="con_more">了解详情</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <!-- <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div> -->
          <!-- 如果需要滚动条 -->
          <!--    <div class="swiper-scrollbar"></div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  props: ["news_list","newlistTemp"],
  data() {
    return {};
  },
  mounted() {
    
  },
  methods: {
    navigator(id, is_ad) {
      this.$emit("itemClick", id, is_ad);
    },
    gonews() {
      this.$router.push({
        path: "news"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.index_news {
  .news-list {
    .news_item {
      cursor: pointer;
      .item_img {
        width: 100%;
        overflow: hidden;
        vertical-align: bottom;
        height: 2rem;
        background-position: center;
        img {
          width: 100%;
          vertical-align: bottom;
          opacity: 0;
        }
      }
      .item_con {
        padding: 0.3rem;
        background: #f5f5f5;
        .con_title {
          font-size: 0.18rem;
          line-height: 0.3rem;
          position: relative;
          height: 0.6rem;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          padding-bottom: 0.1rem;
          text-align: left;
          margin-bottom: 0.2rem;
          ins {
            position: absolute;
            width: 0.6rem;
            height: 0.04rem;
            border-radius: 0.02rem;
            background: #1395ff;
            margin: 0 auto;
            display: inline-block;
            left: 0;
            bottom: 0;
            -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
          }
        }
        .con_desc {
          font-size: 0.12rem;
          line-height: 0.15rem;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          margin-bottom: 0.2rem;
        }
        .con_more {
          color: #1395ff;
          font-size: 0.14rem;
          text-align: left;
        }
      }
      @media (max-width: 991px) {
        .item_img {
          width: 100%;
          overflow: hidden;
          vertical-align: bottom;
          height: 4rem;
          img {
            width: 100%;
            vertical-align: bottom;
          }
        }
        .item_con {
          padding: 0.3rem;
          background: #f5f5f5;
          .con_title {
            font-size: 0.28rem;
            line-height: 0.4rem;
            position: relative;
            height: 0.9rem;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            padding-bottom: 0.1rem;
            text-align: left;
            margin-bottom: 0.2rem;
            ins {
              position: absolute;
              width: 1.2rem;
              height: 0.08rem;
              border-radius: 0.04rem;
              background: #1395ff;
              margin: 0 auto;
              display: inline-block;
              left: 0;
              bottom: 0;
              -webkit-transform: translate(0, 0);
              transform: translate(0, 0);
            }
          }
          .con_desc {
            font-size: 0.26rem;
            line-height: 0.3rem;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            margin-bottom: 0.2rem;
          }
          .con_more {
            color: #1395ff;
            font-size: 0.24rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexnews.vue